<div class="smart-template-assignment-container">
    <!-- Header Section -->
    <div class="assignment-header">
        <div class="header-content">
            <h2 class="assignment-title">
                <mat-icon>link</mat-icon>
                Asignare Smart Template-uri
            </h2>
            <p class="assignment-subtitle">
                Gestionează asignarea template-urilor inteligente la template-urile de documente
            </p>
        </div>
        <div class="header-actions">
            <button mat-stroked-button (click)="refreshAssignments()">
                <mat-icon>refresh</mat-icon>
                Actualizează
            </button>
            <button mat-raised-button color="primary" (click)="saveAssignments()" [disabled]="!hasChanges || isSaving">
                <mat-icon>save</mat-icon>
                {{ isSaving ? 'Se salvează...' : 'Salvează modificări' }}
            </button>
        </div>
    </div>

    <!-- Filters Section -->
    <div class="filters-section">
        <mat-card>
            <mat-card-content>
                <div class="filters-row">
                    <mat-form-field appearance="outline">
                        <mat-label>Categorie document</mat-label>
                        <mat-select [(ngModel)]="selectedCategoryId" (selectionChange)="onCategoryChange()">
                            <mat-option value="">Toate categoriile</mat-option>
                            <mat-option *ngFor="let category of documentCategories" [value]="category.id">
                                {{ category.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Template document</mat-label>
                        <mat-select [(ngModel)]="selectedDocumentTemplateId"
                            (selectionChange)="onDocumentTemplateChange()">
                            <mat-option value="">Toate template-urile</mat-option>
                            <mat-option *ngFor="let docType of filteredDocumentTemplates" [value]="docType.id">
                                {{ docType.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Smart template</mat-label>
                        <mat-select [(ngModel)]="selectedTemplateId" (selectionChange)="onTemplateChange()">
                            <mat-option value="">Toate template-urile</mat-option>
                            <mat-option *ngFor="let template of smartTemplates" [value]="template.id">
                                {{ template.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Status</mat-label>
                        <mat-select [(ngModel)]="selectedStatus" (selectionChange)="applyFilters()">
                            <mat-option value="">Toate</mat-option>
                            <mat-option value="assigned">Asignat</mat-option>
                            <mat-option value="unassigned">Neasignat</mat-option>
                            <mat-option value="multiple">Multiple asignări</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- Main Content -->
    <div class="assignment-content">
        <!-- Left Panel - Document Types -->
        <div class="left-panel">
            <mat-card class="document-types-card">
                <mat-card-header class="mb-3">
                    <mat-card-title>
                        <mat-icon>description</mat-icon>
                        Template-uri de documente
                    </mat-card-title>
                    <div class="card-actions">
                        <mat-checkbox [(ngModel)]="showOnlyUnassigned" (change)="applyFilters()"
                            matTooltip="Afișează doar template-urile fără asignări" color="primary">
                            Doar neasignate
                        </mat-checkbox>
                    </div>
                </mat-card-header>
                <mat-card-content>
                    <div class="document-types-list">
                        <div class="document-type-item"
                            *ngFor="let docType of filteredDocumentTemplates; trackBy: trackDocumentTemplate"
                            [class.selected]="selectedDocumentTemplateId === docType.id"
                            [class.assigned]="hasAssignment(docType.id)"
                            [class.multiple-assignments]="hasMultipleAssignments(docType.id)"
                            (click)="selectDocumentTemplate(docType)">

                            <div class="document-type-header">
                                <div class="document-type-info">
                                    <span class="document-type-name">{{ docType.name }}</span>
                                    <span class="document-type-category">{{ getCategoryName(docType.category_id)
                                        }}</span>
                                </div>
                                <div class="assignment-status">
                                    <mat-icon *ngIf="!hasAssignment(docType.id)" class="status-icon unassigned"
                                        matTooltip="Neasignat">
                                        radio_button_unchecked
                                    </mat-icon>
                                    <mat-icon *ngIf="hasAssignment(docType.id) && !hasMultipleAssignments(docType.id)"
                                        class="status-icon assigned" matTooltip="Asignat">
                                        check_circle
                                    </mat-icon>
                                    <mat-icon *ngIf="hasMultipleAssignments(docType.id)" class="status-icon multiple"
                                        matTooltip="Multiple asignări">
                                        device_hub
                                    </mat-icon>
                                </div>
                            </div>

                            <div class="document-type-details" *ngIf="selectedDocumentTemplateId === docType.id">
                                <p class="document-type-description" *ngIf="docType.description">
                                    {{ docType.description }}
                                </p>
                                <div class="assignment-summary">
                                    <span class="assignments-count">
                                        {{ getAssignmentCount(docType.id) }} asignări
                                    </span>
                                    <span class="last-modified" *ngIf="getLastModified(docType.id)">
                                        Ultima modificare: {{ getLastModified(docType.id) | date:'short' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="empty-state" *ngIf="filteredDocumentTemplates.length === 0">
                        <mat-icon>description</mat-icon>
                        <p>Nu există template-uri de documente care să corespundă filtrelor selectate</p>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- Right Panel - Template Assignments -->
        <div class="right-panel">
            <mat-card class="assignments-card">
                <mat-card-header class="d-flex align-items-center gap-2">
                    <mat-card-title>
                        <mat-icon>auto_awesome</mat-icon>
                        Smart Template-uri asignate
                        <span class="selected-document-name" *ngIf="selectedDocumentTemplate">
                            - {{ selectedDocumentTemplate.name }}
                        </span>
                    </mat-card-title>
                    <div class="card-actions">
                        <button mat-icon-button (click)="addAssignment()" [disabled]="!selectedDocumentTemplate"
                            matTooltip="Adaugă asignare nouă">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content>
                    <!-- Current Assignments -->
                    <div class="assignments-list" *ngIf="currentAssignments.length > 0">
                        <div class="assignment-item" *ngFor="let assignment of currentAssignments; let i = index"
                            [class.modified]="assignment._isModified">

                            <div class="assignment-header">
                                <div class="assignment-info">
                                    <div class="template-info">
                                        <span class="template-name">{{
                                            getTemplateName(assignment.smart_template_group_id) }}</span>
                                        <span class="template-type">{{
                                            getTemplateType(assignment.smart_template_group_id) }}</span>
                                    </div>
                                    <div class="assignment-metadata">
                                        <span class="priority-badge priority-{{ assignment.priority }}">
                                            Prioritate {{ getPriorityLabel(assignment.priority) }}
                                        </span>
                                        <span class="condition-info" *ngIf="assignment.conditions">
                                            <mat-icon>rule</mat-icon>
                                            {{ getConditionSummary(assignment.conditions) }}
                                        </span>
                                    </div>
                                </div>
                                <div class="assignment-actions">
                                    <button mat-icon-button (click)="editAssignment(assignment, i)"
                                        matTooltip="Editează">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button mat-icon-button color="warn" (click)="removeAssignment(i)"
                                        matTooltip="Elimină">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <!-- Assignment Details (Expanded) -->
                            <div class="assignment-details" *ngIf="assignment._expanded">
                                <div class="assignment-form">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Smart template</mat-label>
                                        <mat-select [(ngModel)]="assignment.smart_template_group_id"
                                            (selectionChange)="markAsModified(assignment)">
                                            <mat-option [value]="0" disabled>Selectează un smart
                                                template...</mat-option>
                                            <mat-option *ngFor="let template of smartTemplates" [value]="template.id">
                                                {{ template.name }} ({{ template.type }})
                                            </mat-option>
                                        </mat-select>
                                        <mat-hint *ngIf="assignment.smart_template_group_id === 0">
                                            Este necesar să selectați un smart template pentru această asignare
                                        </mat-hint>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="half-width">
                                        <mat-label>Prioritate</mat-label>
                                        <mat-select [(ngModel)]="assignment.priority"
                                            (selectionChange)="markAsModified(assignment)">
                                            <mat-option [value]="1">Scăzută</mat-option>
                                            <mat-option [value]="2">Normală</mat-option>
                                            <mat-option [value]="3">Ridicată</mat-option>
                                            <mat-option [value]="4">Critică</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="half-width">
                                        <mat-label>Ordine</mat-label>
                                        <input matInput type="number" [(ngModel)]="assignment.order_index"
                                            (ngModelChange)="markAsModified(assignment)" min="0">
                                    </mat-form-field>

                                    <div class="conditions-section">
                                        <h4>Condiții de aplicare</h4>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Condiții (JSON)</mat-label>
                                            <textarea matInput [(ngModel)]="assignment.conditions" rows="3"
                                                (ngModelChange)="markAsModified(assignment)"
                                                placeholder='{"status": "active", "department": "evaluare"}'>
                      </textarea>
                                            <mat-hint>Definiți condiții în format JSON pentru aplicarea
                                                automată</mat-hint>
                                        </mat-form-field>
                                    </div>

                                    <div class="checkbox-group">
                                        <mat-checkbox [(ngModel)]="assignment.is_active"
                                            (change)="markAsModified(assignment)">
                                            Asignare activă
                                        </mat-checkbox>
                                        <mat-checkbox [(ngModel)]="assignment.is_default"
                                            (change)="markAsModified(assignment)">
                                            Template implicit pentru acest tip
                                        </mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Empty State -->
                    <div class="empty-state" *ngIf="currentAssignments.length === 0 && selectedDocumentTemplate">
                        <mat-icon>link_off</mat-icon>
                        <p>Nu există asignări pentru template-ul de document selectat</p>
                        <button mat-stroked-button (click)="addAssignment()">
                            <mat-icon class="mb-0">add</mat-icon>
                            Creează prima asignare
                        </button>
                    </div>

                    <!-- No Document Selected -->
                    <div class="empty-state" *ngIf="!selectedDocumentTemplate">
                        <mat-icon>touch_app</mat-icon>
                        <p>Selectați un template de document din panoul din stânga pentru a vedea asignările</p>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <!-- Statistics Panel -->
    <div class="statistics-panel" *ngIf="showStatistics">
        <mat-card class="stats-card">
            <mat-card-header class="d-flex align-items-center gap-2">
                <mat-card-title>
                    <mat-icon>analytics</mat-icon>
                    Statistici asignări
                </mat-card-title>
                <button mat-icon-button (click)="toggleStatistics()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-card-header>
            <mat-card-content>
                <div class="stats-grid">
                    <div class="stat-item">
                        <span class="stat-number">{{ statisticsData.totalDocumentTypes }}</span>
                        <span class="stat-label">Template-uri de documente</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-number">{{ statisticsData.totalAssignments }}</span>
                        <span class="stat-label">Total asignări</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-number">{{ statisticsData.assignedDocumentTypes }}</span>
                        <span class="stat-label">Tipuri asignate</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-number">{{ statisticsData.unassignedDocumentTypes }}</span>
                        <span class="stat-label">Tipuri neasignate</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-number">{{ statisticsData.activeTemplates }}</span>
                        <span class="stat-label">Template-uri active</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-number">{{ statisticsData.multipleAssignments }}</span>
                        <span class="stat-label">Asignări multiple</span>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- Floating Action Button -->
    <button mat-fab color="accent" class="stats-fab" (click)="toggleStatistics()"
        matTooltip="Afișează/ascunde statistici">
        <mat-icon>{{ showStatistics ? 'close' : 'analytics' }}</mat-icon>
    </button>

    <div class="browser-footer">
        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-secondary" (click)="onClose()">
                <i class="fas fa-times me-1"></i>
                Închide
            </button>
        </div>
    </div>
</div>